import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./TrailerNumberLabel.module.scss";

interface Props {
  currentTrailerNumber?: string | null;
}

const TrailerNumberLabel = ({ currentTrailerNumber }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.value}>
      <span className={styles.label}>{t("transactions.details.trailerNumber.label")}ㅤ</span>
      <span>{currentTrailerNumber || t("empty")}</span>
    </div>
  );
};

export default TrailerNumberLabel;
